import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "position-relative" };
const _hoisted_2 = ["id", "type", "name", "placeholder", "maxlength"];
import ValidateState from '@vue/components/form/ValidateState.vue';
import { useField } from 'vee-validate';
import { computed, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'InputField',
    props: {
        id: {},
        name: {},
        type: {},
        rules: {},
        placeholder: {},
        maxLength: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        const props = __props;
        /**
         * rules 以 computed 傳進 useField，欄位規則才跟得上外部變化
         * （訂位表單依國碼切換 Email 必填／選填就靠這個）。
         *
         * 兩個地雷：
         * - 直接傳 props.rules：掛載當下就定死，之後怎麼改都沒反應。
         * - 傳 getter 函式：useField 的 rules 型別是 MaybeRef 不是 MaybeRefOrGetter，
         *   函式會被當成自訂驗證器執行，等於整個欄位失去規則。
         */
        const rules = computed(() => props.rules);
        const field = useField(() => props.name, rules);
        const validateInputClass = ref();
        const validateTooltipClass = ref();
        watch(() => field.value.value, (v) => {
            emits('update', v);
        });
        function changeValidateState(v) {
            validateInputClass.value = v.inputClass;
            validateTooltipClass.value = v.tooltipClass;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    id: _ctx.id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(field).value.value) = $event)),
                    type: _ctx.type,
                    class: _normalizeClass(["form-control", validateInputClass.value]),
                    name: _ctx.name,
                    placeholder: _ctx.placeholder,
                    maxlength: _ctx.maxLength
                }, null, 10, _hoisted_2), [
                    [_vModelDynamic, _unref(field).value.value]
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(validateTooltipClass.value)
                }, _toDisplayString(_unref(field).errorMessage), 3),
                _createVNode(ValidateState, {
                    field: _unref(field),
                    onValidateState: changeValidateState
                }, null, 8, ["field"])
            ]));
        };
    }
});
